
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "d3160b5b670413ed47b5.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			